import { render, staticRenderFns } from "./NewsOverview.vue?vue&type=template&id=3b2f03d9&scoped=true"
import script from "./NewsOverview.vue?vue&type=script&lang=js"
export * from "./NewsOverview.vue?vue&type=script&lang=js"
import style0 from "./NewsOverview.vue?vue&type=style&index=0&id=3b2f03d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2f03d9",
  null
  
)

export default component.exports